/* K-mita® · kx.js — interacciones del sitio (sin dependencias) */
(() => {
  'use strict';
  const d = document, w = window, root = d.documentElement;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = w.matchMedia('(pointer: fine)').matches;
  const KX = (w.KX = w.KX || {});
  const money = (cents) => {
    try { return new Intl.NumberFormat('es-MX', { style: 'currency', currency: (KX.currency || 'MXN') }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  KX.money = money;

  /* ---------- Toast ---------- */
  let toastT;
  KX.toast = (msg) => {
    let t = $('.kx-toast');
    if (!t) { t = d.createElement('div'); t.className = 'kx-toast'; t.setAttribute('role', 'status'); d.body.appendChild(t); }
    t.innerHTML = '<i><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12.5l4.8 4.8L19.5 7"/></svg></i>' + msg;
    requestAnimationFrame(() => t.classList.add('is-on'));
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-on'), 2600);
  };

  /* ---------- Overlays (menú, carrito, búsqueda, video) ---------- */
  let lastFocus = null;
  const lock = (on) => { d.body.style.overflow = on ? 'hidden' : ''; };
  const openOverlay = (el) => {
    if (!el) return;
    $$('.kx-drawer.is-open, .kx-search.is-open, .kx-modal.is-open').forEach((o) => o !== el && closeOverlay(o, true));
    lastFocus = d.activeElement;
    el.classList.add('is-open'); el.removeAttribute('inert'); el.setAttribute('aria-hidden', 'false'); lock(true);
    const f = el.querySelector('[data-kx-autofocus]') || el.querySelector('button, a, input');
    setTimeout(() => f && f.focus({ preventScroll: true }), 80);
    el.dispatchEvent(new CustomEvent('kx:open'));
  };
  const closeOverlay = (el, silent) => {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); el.setAttribute('inert', ''); lock(false);
    el.dispatchEvent(new CustomEvent('kx:close'));
    if (!silent && lastFocus) lastFocus.focus({ preventScroll: true });
  };
  KX.open = (id) => openOverlay(d.getElementById(id));
  KX.close = (id) => closeOverlay(d.getElementById(id));
  d.addEventListener('click', (e) => {
    const o = e.target.closest('[data-kx-open]');
    if (o) { e.preventDefault(); openOverlay(d.getElementById(o.dataset.kxOpen)); return; }
    const c = e.target.closest('[data-kx-close]');
    if (c) { e.preventDefault(); closeOverlay(c.closest('.kx-drawer, .kx-search, .kx-modal')); }
  });
  d.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.kx-drawer.is-open, .kx-search.is-open, .kx-modal.is-open').forEach((o) => closeOverlay(o));
    if (e.key === 'Tab') {
      const o = $('.kx-drawer.is-open, .kx-search.is-open, .kx-modal.is-open'); if (!o) return;
      const f = $$('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea, iframe', o).filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); KX.open('kx-search'); }
  });

  /* ---------- Header ---------- */
  const header = $('.kx-header');
  if (header) {
    let lastY = w.scrollY, ticking = false;
    const onScroll = () => {
      const y = w.scrollY;
      header.classList.toggle('is-scrolled', y > 12);
      const anyOpen = $('.kx-drawer.is-open, .kx-search.is-open');
      if (!anyOpen) header.classList.toggle('is-hidden', y > 420 && y > lastY + 4);
      if (y < lastY - 4) header.classList.remove('is-hidden');
      lastY = y; ticking = false;
    };
    w.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    onScroll();
    // indicador "blob" del menú
    const list = $('.kx-nav__list', header), blob = $('.kx-nav__blob', header);
    if (list && blob) {
      const move = (a) => { const r = a.getBoundingClientRect(), p = list.getBoundingClientRect(); blob.style.width = r.width + 'px'; blob.style.transform = `translateX(${r.left - p.left}px)`; blob.style.opacity = 1; };
      $$('.kx-nav__link', list).forEach((a) => { a.addEventListener('mouseenter', () => move(a)); a.addEventListener('focus', () => move(a)); });
      list.addEventListener('mouseleave', () => (blob.style.opacity = 0));
    }
  }

  /* ---------- Barra de anuncios ---------- */
  $$('[data-kx-rotator]').forEach((r) => {
    const msgs = $$('.kx-announce__msg', r); if (msgs.length < 2) { msgs[0] && msgs[0].classList.add('is-active'); return; }
    let i = 0; msgs[0].classList.add('is-active');
    setInterval(() => {
      if (d.hidden) return;
      const cur = msgs[i]; i = (i + 1) % msgs.length; const nxt = msgs[i];
      cur.classList.add('is-leaving'); cur.classList.remove('is-active');
      nxt.classList.remove('is-leaving'); nxt.classList.add('is-active');
      setTimeout(() => cur.classList.remove('is-leaving'), 650);
    }, +(r.dataset.kxRotator || 4500));
  });


  /* ---------- Recorte de fondo (#F7F7F7) de fotos de bolsa ---------- */
  const cutout = (img) => {
    if (img.dataset.kxCutDone) return; img.dataset.kxCutDone = 1;
    try {
      const W = img.naturalWidth, H = img.naturalHeight; if (!W || !H) throw 0;
      const c = d.createElement('canvas'); c.width = W; c.height = H;
      const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0);
      const id = x.getImageData(0, 0, W, H), a = id.data, tol = +(img.dataset.kxCutout || 12);
      const r0 = a[0], g0 = a[1], b0 = a[2];
      const diff = (p) => { const i = p * 4; return Math.abs(a[i] - r0) + Math.abs(a[i + 1] - g0) + Math.abs(a[i + 2] - b0); };
      const seen = new Uint8Array(W * H), st = [];
      for (let i = 0; i < W; i++) { st.push(i, (H - 1) * W + i); }
      for (let j = 0; j < H; j++) { st.push(j * W, j * W + W - 1); }
      while (st.length) {
        const p = st.pop(); if (seen[p]) continue; seen[p] = 1;
        if (diff(p) > tol) { seen[p] = 2; continue; }
        a[p * 4 + 3] = 0;
        const px = p % W;
        if (px > 0) st.push(p - 1); if (px < W - 1) st.push(p + 1); if (p >= W) st.push(p - W); if (p < W * (H - 1)) st.push(p + W);
      }
      for (let p = 0; p < W * H; p++) if (seen[p] === 2) { const dd = diff(p); if (dd < tol * 4) a[p * 4 + 3] = Math.round(255 * Math.min(1, (dd - tol) / (tol * 3))); }
      x.putImageData(id, 0, 0);
      c.toBlob((b) => { if (!b) { img.classList.add('is-failed'); return; } img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = URL.createObjectURL(b); img.classList.add('is-cut'); }, 'image/png');
    } catch (e) { img.classList.add('is-failed'); }
  };
  $$('img[data-kx-cutout]').forEach((img) => { setTimeout(() => { if (!img.classList.contains('is-cut')) img.classList.add('is-failed'); }, 3500); if (img.complete && img.naturalWidth) cutout(img); else { img.addEventListener('load', () => cutout(img), { once: true }); img.addEventListener('error', () => img.classList.add('is-failed'), { once: true }); } });

  /* ---------- Revelado + división de palabras ---------- */
  const splitWords = (el) => {
    if (el.dataset.kxSplitDone) return; el.dataset.kxSplitDone = 1;
    let i = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const parts = n.textContent.split(/(\s+)/); const frag = d.createDocumentFragment();
          parts.forEach((p) => {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(p)); return; }
            const o = d.createElement('span'); o.className = 'kx-split-word';
            const inner = d.createElement('span'); inner.style.setProperty('--i', i++); inner.textContent = p;
            o.appendChild(inner); frag.appendChild(o);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
      });
    };
    walk(el);
  };
  $$('.kx-split').forEach(splitWords);
  if ('IntersectionObserver' in w && !reduce) {
    const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('[data-kx-reveal], .kx-split').forEach((el) => io.observe(el));
  } else $$('[data-kx-reveal], .kx-split').forEach((el) => el.classList.add('is-in'));

  /* ---------- Contadores ---------- */
  const counters = $$('[data-kx-count]');
  if (counters.length) {
    const run = (el) => {
      const to = parseFloat(el.dataset.kxCount), dec = +(el.dataset.kxDec || 0), pre = el.dataset.kxPre || '', suf = el.dataset.kxSuf || '';
      if (reduce) { el.textContent = pre + to.toLocaleString('es-MX', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf; return; }
      const t0 = performance.now(), dur = 1600;
      const step = (t) => { const k = Math.min(1, Math.max(0, (t - t0) / dur)), e = 1 - Math.pow(1 - k, 4); el.textContent = pre + (to * e).toLocaleString('es-MX', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf; if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    };
    const io2 = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { run(en.target); io2.unobserve(en.target); } }), { threshold: 0.4 });
    counters.forEach((c) => io2.observe(c));
  }

  /* ---------- Hero: pellets + inclinación del producto ---------- */
  $$('[data-kx-parallax]').forEach((scope) => {
    const pellets = $$('.kx-pellet', scope), prod = $('.kx-hero__product', scope);
    if (!fine || reduce) return;
    let raf;
    scope.addEventListener('pointermove', (e) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const r = scope.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        pellets.forEach((p) => { const z = +(p.dataset.z || 1); p.style.setProperty('--px', (x * -40 * z).toFixed(1) + 'px'); p.style.setProperty('--py', (y * -40 * z).toFixed(1) + 'px'); });
        if (prod) { prod.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg'); prod.style.setProperty('--rx', (y * -10).toFixed(2) + 'deg'); }
      });
    });
    scope.addEventListener('pointerleave', () => { pellets.forEach((p) => { p.style.setProperty('--px', '0px'); p.style.setProperty('--py', '0px'); }); if (prod) { prod.style.setProperty('--ry', '0deg'); prod.style.setProperty('--rx', '0deg'); } });
  });

  /* ---------- Un día con tu michi (scroll) ---------- */
  $$('.kx-day').forEach((sec) => {
    const track = $('.kx-day__track', sec), steps = $$('.kx-day__step', sec), bars = $$('.kx-day__progress span', sec);
    const sun = $('.kx-scene-sun', sec), cat = $('.kx-scene-cat', sec);
    const n = steps.length; if (!track || !n) return;
    const desktop = w.matchMedia('(min-width: 990px)');
    let cur = -1;
    const set = (idx) => {
      if (idx === cur) return; cur = idx;
      sec.dataset.step = idx + 1;
      steps.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      if (sun) sun.style.transform = ['translate(0px, 40px)', 'translate(150px, -30px)', 'translate(300px, 120px)'][idx] || '';
      if (cat) cat.style.transform = ['translate(0px, 0px)', 'translate(196px, -14px)', 'translate(0px, 0px)'][idx] || '';
    };
    const onScroll = () => {
      if (!desktop.matches) { steps.forEach((s) => s.classList.add('is-active')); return; }
      const r = track.getBoundingClientRect(), total = r.height - w.innerHeight;
      const p = Math.min(1, Math.max(0, -r.top / total));
      const idx = Math.min(n - 1, Math.floor(p * n * 0.999));
      bars.forEach((b, i) => b.style.setProperty('--f', Math.min(1, Math.max(0, p * n - i)).toFixed(3)));
      set(idx);
    };
    set(0);
    w.addEventListener('scroll', () => requestAnimationFrame(onScroll), { passive: true });
    w.addEventListener('resize', onScroll); onScroll();
  });

  /* ---------- Laboratorio: pellet → aserrín ---------- */
  $$('[data-kx-lab]').forEach((lab) => {
    const svg = $('svg.kx-lab__svg', lab), range = $('.kx-range', lab), state = $('.kx-lab__state', lab), labels = $$('.kx-lab__labels span', lab);
    if (!svg || !range) return;
    const NS = 'http://www.w3.org/2000/svg';
    const W = 600, H = 260; svg.setAttribute('viewBox', `0 0 ${W} ${H}`);
    const msgs = (lab.dataset.states || '').split('|');
    const items = [];
    let seed = 7; const rnd = () => ((seed = (seed * 16807) % 2147483647) / 2147483647);
    // capa de aserrín (fondo)
    const dustG = d.createElementNS(NS, 'g'), pelG = d.createElementNS(NS, 'g');
    svg.appendChild(dustG); svg.appendChild(pelG);
    const defs = d.createElementNS(NS, 'defs');
    defs.innerHTML = '<linearGradient id="kxPel" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#F3DFC0"/><stop offset=".55" stop-color="#DDB98A"/><stop offset="1" stop-color="#B98E5E"/></linearGradient>';
    svg.prepend(defs);
    const cols = 15, rows = 5;
    for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) {
      const x = 30 + c * 38 + (r % 2) * 18 + (rnd() - 0.5) * 10, y = 80 + r * 30 + (rnd() - 0.5) * 8;
      const rot = (rnd() - 0.5) * 120, th = 0.15 + rnd() * 0.8;
      const g = d.createElementNS(NS, 'g'); g.setAttribute('transform', `translate(${x} ${y}) rotate(${rot})`);
      const p = d.createElementNS(NS, 'rect'); p.setAttribute('x', -7); p.setAttribute('y', -15); p.setAttribute('width', 14); p.setAttribute('height', 30); p.setAttribute('rx', 7); p.setAttribute('fill', 'url(#kxPel)');
      const hl = d.createElementNS(NS, 'rect'); hl.setAttribute('x', -3); hl.setAttribute('y', -12); hl.setAttribute('width', 6); hl.setAttribute('height', 5); hl.setAttribute('rx', 2.5); hl.setAttribute('fill', 'rgba(255,255,255,.5)');
      g.appendChild(p); g.appendChild(hl); g.style.transition = 'transform .5s cubic-bezier(.2,.8,.2,1), opacity .5s';
      const inner = d.createElementNS(NS, 'g'); inner.appendChild(g); pelG.appendChild(inner);
      const dust = [];
      for (let k = 0; k < 7; k++) {
        const dc = d.createElementNS(NS, 'circle');
        dc.setAttribute('cx', x + (rnd() - 0.5) * 34); dc.setAttribute('cy', y + 10 + rnd() * 26); dc.setAttribute('r', 1.4 + rnd() * 2.6);
        dc.setAttribute('fill', ['#C9A274', '#B88B5A', '#E2C49A', '#A57A4B'][k % 4]); dc.style.opacity = 0; dc.style.transition = 'opacity .5s, transform .6s cubic-bezier(.2,.8,.2,1)';
        dustG.appendChild(dc); dust.push(dc);
      }
      items.push({ inner, th, dust, x, y });
    }
    // "humedad": gotas
    const drops = d.createElementNS(NS, 'g'); svg.appendChild(drops);
    for (let k = 0; k < 6; k++) { const dr = d.createElementNS(NS, 'path'); const x = 80 + k * 90; dr.setAttribute('d', `M${x} 10 q6 10 0 14 q-6 -4 0 -14z`); dr.setAttribute('fill', '#F7A1BC'); dr.style.opacity = 0; dr.style.transition = 'opacity .4s, transform .8s'; drops.appendChild(dr); }
    const render = (v) => {
      const k = v / 100;
      range.style.setProperty('--v', v + '%');
      items.forEach((it) => {
        const t = Math.min(1, Math.max(0, (k - it.th * 0.75) / 0.25));
        it.inner.style.opacity = 1 - t;
        it.inner.style.transform = `translate(0px, ${t * 18}px) scale(${1 - t * 0.6})`;
        it.inner.style.transformOrigin = `${it.x}px ${it.y}px`;
        it.dust.forEach((dc, j) => { dc.style.opacity = t > 0.05 ? Math.min(1, t * 1.4) : 0; dc.style.transform = `translateY(${(1 - t) * -10}px)`; });
      });
      [...drops.children].forEach((dr, j) => { dr.style.opacity = k > 0.04 && k < 0.85 ? 0.9 : 0; dr.style.transform = `translateY(${k * 40 + j * 3}px)`; });
      const idx = Math.min(3, Math.floor(k * 3.999));
      labels.forEach((l, i) => l.classList.toggle('is-on', i <= idx));
      if (state && msgs[idx] && state.dataset.idx != idx) { state.dataset.idx = idx; state.innerHTML = msgs[idx]; state.classList.remove('kx-flip'); void state.offsetWidth; state.classList.add('kx-flip'); }
      range.setAttribute('aria-valuetext', (msgs[idx] || '').replace(/<[^>]+>/g, ''));
    };
    range.addEventListener('input', () => { lab.dataset.touched = 1; render(+range.value); });
    render(+range.value);
    // demo automática la primera vez que se ve
    if (!reduce && 'IntersectionObserver' in w) {
      const io = new IntersectionObserver((ents) => {
        if (!ents[0].isIntersecting) return; io.disconnect();
        let v = 0; const tick = () => { if (lab.dataset.touched) return; v += 0.9; range.value = Math.min(v, 72); render(+range.value); if (v < 72) requestAnimationFrame(tick); };
        setTimeout(tick, 500);
      }, { threshold: 0.5 });
      io.observe(lab);
    }
  });

  /* ---------- Video modal ---------- */
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-kx-video]'); if (!b) return;
    e.preventDefault();
    let m = d.getElementById('kx-video');
    if (!m) {
      m = d.createElement('div'); m.id = 'kx-video'; m.className = 'kx-modal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', 'Video');
      m.innerHTML = '<div class="kx-modal__scrim" data-kx-close></div><div class="kx-modal__box"><button class="kx-iconbtn kx-modal__close" data-kx-close aria-label="Cerrar video"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button><div class="kx-modal__frame" style="width:100%;height:100%"></div></div>';
      d.body.appendChild(m);
      m.addEventListener('kx:close', () => { $('.kx-modal__frame', m).innerHTML = ''; });
    }
    $('.kx-modal__frame', m).innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(b.dataset.kxVideo)}?autoplay=1&rel=0&modestbranding=1" title="${b.dataset.kxVideoTitle || 'Video'}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
    openOverlay(m);
  });

  /* ---------- Control segmentado / filtros ---------- */
  $$('[data-kx-seg]').forEach((seg) => {
    const btns = $$('button', seg), thumb = $('.kx-seg__thumb', seg);
    const scope = d.getElementById(seg.dataset.kxSeg) || seg.closest('section');
    const place = (b) => { if (!thumb) return; thumb.style.width = b.offsetWidth + 'px'; thumb.style.transform = `translateX(${b.offsetLeft}px)`; };
    const apply = (b) => {
      btns.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false')); place(b);
      const f = b.dataset.filter;
      $$('[data-bag]', scope).forEach((c) => {
        const show = f === 'all' || c.dataset.bag === f;
        if (show && c.classList.contains('is-hidden')) { c.classList.remove('is-hidden'); c.animate && !reduce && c.animate([{ opacity: 0, transform: 'translateY(16px) scale(.98)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: 'cubic-bezier(.2,.8,.2,1)' }); }
        else if (!show) c.classList.add('is-hidden');
      });
    };
    btns.forEach((b) => b.addEventListener('click', () => apply(b)));
    const init = btns.find((b) => b.getAttribute('aria-pressed') === 'true') || btns[0];
    requestAnimationFrame(() => apply(init));
    w.addEventListener('resize', () => place(btns.find((b) => b.getAttribute('aria-pressed') === 'true') || btns[0]));
    if (d.fonts) d.fonts.ready.then(() => place(btns.find((b) => b.getAttribute('aria-pressed') === 'true') || btns[0]));
  });

  /* Orden por precio / kg (colección) */
  $$('[data-kx-sort]').forEach((sel) => {
    const grid = d.getElementById(sel.dataset.kxSort); if (!grid) return;
    sel.addEventListener('change', () => {
      const cards = $$('.kx-pcard', grid), v = sel.value;
      const key = (c) => v === 'perkg' ? +c.dataset.perkg : v === 'price-asc' ? +c.dataset.price : v === 'price-desc' ? -c.dataset.price : v === 'kg-desc' ? -c.dataset.kg : +c.dataset.index;
      cards.sort((a, b) => key(a) - key(b)).forEach((c) => grid.appendChild(c));
    });
  });

  /* ---------- Carrito (Ajax API + Section Rendering) ---------- */
  const CART_SECTION = 'kx-cart-drawer';
  const cartRoot = () => d.getElementById('kx-cart');
  const updateCount = (count) => {
    $$('[data-kx-cart-count]').forEach((el) => { el.textContent = count; });
    $$('.kx-cart-btn').forEach((b) => { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); b.setAttribute('aria-label', `Carrito, ${count} artículos`); });
  };
  const renderCart = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const c = doc.querySelector('[data-kx-count-src]');
    const count = c ? c.dataset.kxCountSrc : null;
    const fresh = doc.querySelector('#kx-cart-inner'), cur = d.getElementById('kx-cart-inner');
    if (fresh && cur) cur.replaceWith(fresh);
    if (count !== null) updateCount(count);
    // página de carrito
    if (d.getElementById('kx-cart-page')) setTimeout(() => location.reload(), 350);
  };
  const fetchCart = () => fetch(`/?sections=${CART_SECTION}`).then((r) => r.json()).then((j) => renderCart(j[CART_SECTION]));
  KX.addToCart = async (items, btn) => {
    btn && btn.classList.add('is-loading');
    try {
      const r = await fetch((w.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: CART_SECTION, sections_url: location.pathname }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'No se pudo agregar');
      renderCart(j.sections && j.sections[CART_SECTION]);
      if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-done'); setTimeout(() => btn.classList.remove('is-done'), 1600); }
      if (!d.getElementById('kx-cart-page')) openOverlay(cartRoot()); else KX.toast('Agregado a tu carrito');
      d.dispatchEvent(new CustomEvent('kx:cart:added', { detail: j }));
    } catch (err) {
      btn && btn.classList.remove('is-loading');
      KX.toast(err.message || 'Ups, inténtalo de nuevo');
    }
  };
  const changeLine = async (line, quantity, el) => {
    el && el.classList.add('is-busy');
    const r = await fetch((w.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity, sections: CART_SECTION, sections_url: location.pathname }) });
    const j = await r.json();
    if (!r.ok) { el && el.classList.remove('is-busy'); KX.toast(j.description || 'No se pudo actualizar'); return; }
    renderCart(j.sections && j.sections[CART_SECTION]);
  };
  d.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-kx-atc]'); if (!f) return;
    e.preventDefault();
    const fd = new FormData(f);
    KX.addToCart([{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }], f.querySelector('[type=submit]'));
  });
  d.addEventListener('click', (e) => {
    const a = e.target.closest('[data-kx-add]');
    if (a) { e.preventDefault(); e.stopPropagation(); KX.addToCart([{ id: +a.dataset.kxAdd, quantity: +(a.dataset.qty || 1) }], a); return; }
    const q = e.target.closest('[data-kx-line-qty]');
    if (q) { e.preventDefault(); const li = q.closest('[data-line]'); changeLine(+li.dataset.line, Math.max(0, +li.dataset.qty + +q.dataset.kxLineQty), li); return; }
    const rm = e.target.closest('[data-kx-line-remove]');
    if (rm) { e.preventDefault(); const li = rm.closest('[data-line]'); changeLine(+li.dataset.line, 0, li); }
  });
  const cr = cartRoot(); if (cr) cr.addEventListener('kx:open', () => { if (!cr.dataset.loaded) { cr.dataset.loaded = 1; } });
  w.addEventListener('pageshow', (e) => { if (e.persisted) fetchCart(); });

  /* Cantidad (PDP) */
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-kx-step]'); if (!b) return;
    const input = b.parentElement.querySelector('input'); if (!input) return;
    input.value = Math.max(1, (+input.value || 1) + +b.dataset.kxStep);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Rieles (reseñas) ---------- */
  $$('.kx-rail').forEach((rail) => {
    const nav = rail.parentElement.querySelector('.kx-rail-nav') || (rail.dataset.nav && d.getElementById(rail.dataset.nav));
    if (nav) $$('button', nav).forEach((b) => b.addEventListener('click', () => rail.scrollBy({ left: (+b.dataset.dir) * Math.min(rail.clientWidth * 0.8, 800), behavior: 'smooth' })));
    if (!fine) return;
    let down = false, sx = 0, sl = 0, moved = false;
    rail.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; });
    w.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; rail.classList.add('is-drag'); } rail.scrollLeft = sl - dx; });
    w.addEventListener('pointerup', () => { if (!down) return; down = false; setTimeout(() => rail.classList.remove('is-drag'), 0); });
    rail.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  /* ---------- Calculadora de rendimiento ---------- */
  $$('[data-kx-calc]').forEach((calc) => {
    let data; try { data = JSON.parse($('script[type="application/json"]', calc).textContent); } catch (e) { return; }
    const prods = (data.products || []).filter((p) => p.available !== false);
    const ten = prods.filter((p) => p.bagsize >= 10).sort((a, b) => a.kg - b.kg);
    const trial = prods.filter((p) => p.bagsize < 10).sort((a, b) => a.kg - b.kg)[0];
    const kgPerCatWeek = data.kgPerCatWeek || 1.25;
    const out = {
      weeks: $('[data-o="weeks"]', calc), unit: $('[data-o="unit"]', calc), day: $('[data-o="day"]', calc), michiDay: $('[data-o="michiday"]', calc), months: $('[data-o="months"]', calc),
      img: $('[data-o="img"]', calc), title: $('[data-o="title"]', calc), meta: $('[data-o="meta"]', calc), link: $('[data-o="link"]', calc), add: $('[data-o="add"]', calc), trial: $('[data-o="trial"]', calc)
    };
    const pick = (cats) => { const need = cats * 10; return ten.find((p) => p.kg >= need) || ten[ten.length - 1] || prods[0]; };
    const flip = (el, txt) => { if (!el) return; el.textContent = txt; el.classList.remove('kx-flip'); void el.offsetWidth; el.classList.add('kx-flip'); };
    const update = (cats) => {
      const p = pick(cats); if (!p) return;
      const weeks = p.kg / (kgPerCatWeek * cats), days = weeks * 7;
      flip(out.weeks, weeks >= 10 ? Math.round(weeks) : weeks.toFixed(1).replace('.0', ''));
      out.unit && (out.unit.textContent = 'semanas');
      out.months && (out.months.textContent = (weeks / 4.345).toFixed(1).replace('.0', ''));
      flip(out.day, money(Math.round(p.price / days)));
      out.michiDay && (out.michiDay.textContent = money(Math.round(p.price / days / cats)));
      if (out.img) { out.img.src = p.img; out.img.alt = p.title; }
      out.title && (out.title.textContent = p.title);
      out.meta && (out.meta.textContent = `${money(p.price)} · ${money(Math.round(p.price / p.kg))}/kg`);
      out.link && (out.link.href = p.url);
      out.add && (out.add.dataset.kxAdd = p.variant);
      if (out.trial && trial) { out.trial.href = trial.url; }
    };
    $$('.kx-cats button', calc).forEach((b) => b.addEventListener('click', () => {
      $$('.kx-cats button', calc).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      update(+b.dataset.cats);
    }));
    update(+(($('.kx-cats button[aria-pressed="true"]', calc) || {}).dataset || {}).cats || 1);
  });

  /* Medidor de rendimiento en PDP */
  $$('[data-kx-meter]').forEach((m) => {
    const kg = +m.dataset.kg, per = +(m.dataset.rate || 1.25), out = $('[data-o="weeks"]', m), bar = $('.kx-meter__bar i', m);
    const upd = (c) => { const wk = kg / (per * c); out.textContent = (wk >= 10 ? Math.round(wk) : wk.toFixed(1).replace('.0', '')) + (wk < 2 ? ' semana' : ' semanas'); bar.style.setProperty('--w', Math.min(100, (wk / 24) * 100).toFixed(1) + '%'); };
    $$('button', m).forEach((b) => b.addEventListener('click', () => { $$('button', m).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false')); upd(+b.dataset.cats); }));
    upd(1);
  });

  /* ---------- Galería de producto ---------- */
  $$('[data-kx-gallery]').forEach((g) => {
    const track = $('.kx-gallery__track', g), slides = $$('.kx-gallery__slide', g), thumbs = $$('.kx-gallery__thumbs button', g), dots = $$('.kx-gallery__dots span', g);
    if (!track) return;
    const go = (i) => track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    const mark = (i) => { thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false')); dots.forEach((x, k) => x.classList.toggle('is-on', k === i)); };
    track.addEventListener('scroll', () => { const i = Math.round(track.scrollLeft / track.clientWidth); mark(i); }, { passive: true });
    mark(0);
    if (fine) slides.forEach((s) => {
      s.addEventListener('click', () => s.classList.toggle('is-zoom'));
      s.addEventListener('pointermove', (e) => { const r = s.getBoundingClientRect(); s.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%'); s.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%'); });
      s.addEventListener('pointerleave', () => s.classList.remove('is-zoom'));
    });
  });

  /* Barra de compra fija */
  $$('[data-kx-sticky-buy]').forEach((bar) => {
    const target = d.getElementById(bar.dataset.kxStickyBuy); if (!target || !('IntersectionObserver' in w)) return;
    const foot = $('.kx-footer');
    let mainVisible = true, footVisible = false;
    const sync = () => bar.classList.toggle('is-on', !mainVisible && !footVisible);
    new IntersectionObserver((e) => { mainVisible = e[0].isIntersecting || e[0].boundingClientRect.top > 0; sync(); }).observe(target);
    if (foot) new IntersectionObserver((e) => { footVisible = e[0].isIntersecting; sync(); }).observe(foot);
  });

  /* ---------- Acordeones con animación ---------- */
  $$('details.kx-acc').forEach((det) => {
    const sum = $('summary', det), body = $('.kx-acc__body', det); if (!sum || !body || reduce) return;
    sum.addEventListener('click', (e) => {
      e.preventDefault();
      if (det.dataset.anim) return; det.dataset.anim = 1;
      if (det.open) {
        const h = body.offsetHeight;
        body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.2,.8,.2,1)' }).onfinish = () => { det.open = false; delete det.dataset.anim; };
      } else {
        if (det.dataset.group) $$(`details.kx-acc[data-group="${det.dataset.group}"][open]`).forEach((o) => o !== det && (o.open = false));
        det.open = true; const h = body.offsetHeight;
        body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' }).onfinish = () => delete det.dataset.anim;
      }
    });
  });

  /* ---------- Búsqueda predictiva ---------- */
  const search = d.getElementById('kx-search');
  if (search) {
    const input = $('.kx-search__input', search), out = $('.kx-search__results', search), hint = $('.kx-search__hint', search);
    let ctrl, t;
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const run = (q) => {
      if (!q.trim()) { out.innerHTML = ''; hint && (hint.hidden = false); return; }
      hint && (hint.hidden = true);
      ctrl && ctrl.abort(); ctrl = new AbortController();
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,page,article&resources[limit]=6&resources[options][unavailable_products]=last`, { signal: ctrl.signal })
        .then((r) => r.json()).then((j) => {
          const res = j.resources && j.resources.results || {}; const ps = res.products || [], pg = (res.pages || []).concat(res.articles || []);
          if (!ps.length && !pg.length) { out.innerHTML = `<p class="kx-note" style="padding:16px">Sin resultados para “${esc(q)}”. Prueba con “10 kg” o “arena”.</p>`; return; }
          out.innerHTML = ps.map((p) => `<a class="kx-sres" href="${p.url}"><img src="${p.image || p.featured_image && p.featured_image.url || ''}" alt="" loading="lazy" width="64" height="64"><span><b>${esc(String(p.title).split('|')[0])}</b><small>${p.price ? money(Math.round(parseFloat(p.price) * 100)) : ''}</small></span><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12h15M13.5 6l6 6-6 6"/></svg></a>`).join('')
            + pg.map((p) => `<a class="kx-sres" href="${p.url}" style="grid-template-columns:1fr auto"><span><b>${esc(p.title)}</b><small>Página</small></span><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12h15M13.5 6l6 6-6 6"/></svg></a>`).join('')
            + `<a class="kx-link" style="margin:12px" href="/search?q=${encodeURIComponent(q)}&type=product">Ver todos los resultados</a>`;
        }).catch(() => {});
    };
    input && input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => run(input.value), 160); });
    $$('.kx-search__hint button', search).forEach((b) => b.addEventListener('click', () => { input.value = b.textContent.trim(); run(input.value); input.focus(); }));
  }

  /* ---------- Editor de temas ---------- */
  d.addEventListener('shopify:section:load', (e) => {
    $$('[data-kx-reveal], .kx-split', e.target).forEach((el) => el.classList.add('is-in'));
    $$('img[data-kx-cutout]', e.target).forEach((img) => img.classList.add('is-failed'));
  });
  KX.ready = true;

  /* ---------- Formulario de contacto/newsletter: estado enviado ---------- */
  if (location.search.includes('customer_posted=true') || location.hash === '#kx-news') {
    const n = d.getElementById('kx-news'); n && n.scrollIntoView({ block: 'center' });
  }
})();
